import { ISymbol } from '../SymbolSelect'

/**
 * Filters out 'stock' type symbols for backtest components
 * This ensures that only forex, crypto, and other non-stock symbols are available for backtesting
 */
const backtesterFilter = (symbols: ISymbol[]) => {
  return symbols.filter((symbol: ISymbol) => symbol.type !== 'stock')
}

export default backtesterFilter
